import React, { useEffect, useState } from "react";
import { ShimmerSocialPost, ShimmerThumbnail } from "react-shimmer-effects";
import axios, { buildVideoIndexerManifestUrl } from "../../API/axios";
import { getEmojiDDL } from "../../Services/apiService";
import { NewsFeed, post, svg } from "../../config/imagesLink";
// import AddPost from "./AddPost";
// import PostInteractionModal from "./PostInteractionModal";
import { Col, Modal, Row } from "react-bootstrap";
// import PostComment from "./PostComment";
// import PostEngagement from "./PostEngagement";
import Carousel from "react-bootstrap/Carousel";
import Loading from "../Blogs/Loading";
import moment from "moment";
import PostEngagement from "../NewsFeed/PostEngagement";
import PostComment from "../NewsFeed/PostComment";
import PostInteractionModal from "../NewsFeed/PostInteractionModal";
import AddPost from "../NewsFeed/AddPost";
import { Link } from "react-router-dom";
import Comment from "../NewsFeed/Comment";
import ImageSliderModal from "../NewsFeed/ImageSliderModal";
import { ShimmerDiv, ImageWithLoader } from "@skeleton";
import PostComponent from "../NewsFeed/PostComponent";
import LikesDetails from "../NewsFeed/LikesDetails";
import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { useRef } from "react";
import Advertisement from "../NewsFeed/PostAdvertisement";
import PostVideoCommon from "../PersonalProfile/PostVideoCommon";
import { useTranslation } from "react-i18next";
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ReplyAllOutlinedIcon from '@mui/icons-material/ReplyAllOutlined';
import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";
import { Tooltip } from "@mui/material";

const { pin } = svg;

const Posts = ({ CompUid, companyDetails, setProgress, setIsVideoProcessing ,setCompanyStats, CompanyStatsCount}) => {
  const guestModeData = localStorage.getItem("guestMode");
  const restrictedViewerTokens = localStorage.getItem("restrictedViewerToken");
  const language = localStorage.getItem("Lang");
  const { t } = useTranslation();

    const localeMap = {
      en: "en",
      ar: "ar",
      hi: "hi",
    };

const locale = localeMap[language] || "en";

  //************************ All Post List  ************************//
  const [postList, setPostList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isError, setIsError] = useState(false);
  const [isfollowed, setIsfollowed] = useState(false);
  const [mediaFiles, setMediaFiles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [singlePostContent, setSinglePostContent] = useState("");
  const [singlepostId, setSinglePostId] = useState("");
  const [ispostmodalOpen, setIspostmodalOpen] = useState(false);
  const [postId, setPostId] = useState("");
  const [postLikedType, setPostLikedType] = useState(false);
  const [dLike, setDLike] = useState(0);
  const [modalImages, setModalImages] = useState([]);
  const [initialSlideIndex, setInitialSlideIndex] = useState(0);
  const [imageArray, setImageArray] = useState([]);
  const [emojiList, setemojiList] = useState();
  const [restrictedViewerToken, setRestrictedViewerToken] = useState('');
  const [isLiked, setIsLiked] = useState(false);

    const visibleVideoRef = useRef(null);
      const [activeVideoId, setActiveVideoId] = useState(null);
    
  
  const GetEmoji = async () => {
    try {
      const responseData = await getEmojiDDL(language);
      setemojiList(responseData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    GetEmoji();
  }, []);
  const handleLikesCloseModal = () => {
    setShowModal(false);
    // setSelectedItem(null);
  };
  const [sliderSettings, setSliderSettings] = useState({
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  });

  const openModal = (mediaFiles, initialSlide) => {
    setIsLoading(true);

    setSliderSettings((prevSettings) => ({
      ...prevSettings,
      initialSlide: initialSlide,
    }));
    setMediaFiles(mediaFiles);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  console.log("isError", companyDetails);
  const [nextBatchLoading, setNextBatchLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  
const AllPostList = async (page) => {
    const data = {
      deviceType: "Web",
      pageNumber: page,
      pageSize: 8,
      langKey: language === "en" ? "" : language,
    };

    try {
      // setIsLoading(true);
      setNextBatchLoading(true);
      const resData = await axios.post(`Posts/GetCompanyPosts?CompanyUid=${CompUid}`, data);
      setIsLoading(false);

      setTotalPages(resData.data.responseData.paging.totalPages);
      const newPosts = resData.data.responseData.dataList;
      // console.log("NewPOstData===>", newPosts)

      const currentScroll = window.scrollY;
      setPostList((prev) => {
        const postSet = new Set(prev.map((post) => post.postInfo.postId));
        const uniqueNewPosts = newPosts.filter(
          (post) => !postSet.has(post.postInfo.postId)
        );
        setTimeout(() => {
          window.scrollTo({ top: currentScroll });
        }, 50);

        setRestrictedViewerToken(resData?.data?.responseData?.restrictedViewerToken);
        return [...prev, ...uniqueNewPosts];
      });

      if (page >= resData.data.responseData.paging.totalPages) {
        setHasMoreData(false);
      }
      setNextBatchLoading(false);

    } catch (error) {
      if (error.response && error.response.status === 404) {
        setIsError(true);
      } else {
        console.error(error);
      }
      setNextBatchLoading(false);
    }
  };

  useEffect(() => { 
    if (hasMoreData && page <= totalPages) {
      AllPostList(page);
    }
  }, [page, CompUid]);

  const handelInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        setLoading(true);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handelInfiniteScroll);
    return () => window.removeEventListener("scroll", handelInfiniteScroll);
  }, []);


  const getPostListWithAds = (posts) => {
  const result = [];
  posts.forEach((post, index) => {
    result.push(post); 
    if ((index + 1) % 8 === 0) {
      result.push({ isAd: true });
    }
  });
  return result;
};
  const postsWithAds = getPostListWithAds(postList);

  //************************ All Post List  ************************//
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  // useEffect(() => {
  //   if (showModal) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [showModal]);

  // const updateLikeCount = (postId, delta) => {
  //   setPostList((prev) =>
  //     prev.map((post) =>
  //       post.postId === postId
  //         ? { ...post, likeCount: post.likeCount + delta }
  //         : post
  //     )
  //   );
  // };
const updateLikeCount = (postId, delta) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postInfo.postId === postId
          ? {
            ...post,
            postInfo: {
              ...post.postInfo,
              likeCount: post.postInfo.likeCount + delta,
            },
          }
          : post
      )
    );
  };

 const updatePostLike = (postId, isLikedStatus, likedType) => {
   
    setPostList((prev) =>
      prev.map((post) => {
        if (post.postInfo.postId === postId) {
          
          return {
            ...post,
            postInfo: {
              ...post.postInfo,
              // likeCount: newLikeCount,
              postActionsInfo: {
                ...post.postInfo.postActionsInfo,
                isLiked: isLikedStatus,
                likedType: likedType,
              },
            },
          };
        }
        return post;
      })
    );
  };

  const updateCommentLike = (postId, commentId, action, likeType = null) => {
    setPostList((prevList) =>
      prevList.map((item) => {
        if (item?.postInfo?.postId !== postId) return item;

        return {
          ...item,
          postInfo: {
            ...item.postInfo,
            comments: (item.postInfo.comments || []).map((c) => {
              if (c.pstCmntId !== commentId) return c;

              if (action === "like") {
                return {
                  ...c,
                  likeCount: (c.likeCount || 0) + 1,
                  isLiked: true,
                  likedType: likeType,
                };
              }

              if (action === "unlike") {
                return {
                  ...c,
                  likeCount: Math.max((c.likeCount || 1) - 1, 0),
                  isLiked: false,
                  likedType: null,
                };
              }

              if (action === "change") {
                return {
                  ...c,
                  isLiked: true,
                  likedType: likeType, // count same, type replace
                };
              }

              return c;
            }),
          },
        };
      })
    );
  };

const updateReplyCommentLike = (postId, commentId, replyId, action, likeType = null) => {
    setPostList((prevList) =>
      prevList.map((post) => {
        // postId check
        if (post.postInfo.postId !== postId) return post;

        return {
          ...post,
          postInfo: {
            ...post.postInfo,
            comments: (post.postInfo.comments || []).map((c) => {
              // commentId check
              if (c.pstCmntId !== commentId) return c;

              return {
                ...c,
                commentsReplies: (c.commentsReplies || []).map((reply) => {
                  if (reply.pstCmntRplyId !== replyId) return reply;

                  if (action === "like") {
                    return {
                      ...reply,
                      isLiked: true,
                      likeCount: (reply.likeCount || 0) + 1,
                      likedType: likeType,
                    };
                  }

                  if (action === "unlike") {
                    return {
                      ...reply,
                      isLiked: false,
                      likeCount: reply.likeCount > 0 ? reply.likeCount - 1 : 0,
                      likedType: null,
                    };
                  }

                  if (action === "change") {
                    return {
                      ...reply,
                      likedType: likeType,
                    };
                  }

                  return reply;
                }),
              };
            }),
          },
        };
      })
    );
  };

  const updateCommentCount = (postId, change) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postId === postId
          ? { ...post, commentCount: post.commentCount + change }
          : post
      )
    );
  };

  const updateShareCount = (postId, change) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postId === postId
          ? { ...post, shareCount: post.shareCount + change }
          : post
      )
    );
  };

  const handleShowModal = (item) => {
    console.log('gsadhfs', item);

    setPostId(item?.postInfo?.postId);
    setPostLikedType(item?.postInfo?.likedType);
    setShowModal(true);
  };
  const [showDeletePost, setShowDeletePost] = useState(false)
  console.log('isModalOpen', isModalOpen);

  const videoRefs = useRef({});
  useEffect(() => {
    if (!postList || !restrictedViewerToken) return;

    postList.forEach(item => {
      item?.postInfo?.mediaFilesList?.forEach(file => {
        const videoId = file?.mediaInfo;
        const videoEl = videoRefs.current[videoId];
        const region = "centralindia";
        // const accountId = "3933d146-5f68-41d4-93a3-d2f7454d4a8d";

        if (!videoId || !videoEl) return;

        const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerToken, region: region });

        // if (Hls.isSupported()) {
        //   const hls = new Hls();
        //   hls.loadSource(manifestUrl);
        //   hls.attachMedia(videoEl);

        //   hls.on(Hls.Events.MANIFEST_PARSED, () => {
        //     console.log("✅ Manifest parsed for", videoId);
        //   });

        //   hls.on(Hls.Events.ERROR, (event, data) => {
        //     console.error("HLS.js Error:", data);
        //   });
        // } else if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
        //   videoEl.src = manifestUrl;
        // }
        
        let hls;
        let plyrInstance;

        if (Hls.isSupported()) {
          hls = new Hls();
          hls.loadSource(manifestUrl);
          hls.attachMedia(videoEl);

          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            plyrInstance = new Plyr(videoEl, {
              captions: { active: true, update: true, language: "en" },
            });
            videoEl.muted = true; // always start muted
            videoEl?.play().catch(err => console.warn("Autoplay blocked", err));
          });

          hls.on(Hls.Events.ERROR, (event, data) => {
            console.error("HLS.js Error:", data);
          });
        } else if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
          videoEl.src = manifestUrl;
          plyrInstance = new Plyr(videoEl);
          videoEl.addEventListener("loadedmetadata", () => {
            videoEl?.play();
          });
        }

        // Cleanup
        return () => {
          if (plyrInstance) plyrInstance.destroy();
          if (hls) hls.destroy();
        };
      });
    });
  }, [postList, restrictedViewerToken]);

    

 console.log("companyDetails", companyDetails.compUid);
 
  return (
    <>
      {companyDetails?.isOwned &&
        <AddPost
          AllPostList={AllPostList}
          companyDetails={companyDetails}
          PostOriginType={"Company"}
          postOriginId={CompUid}
          setPostList={setPostList}
          postList={postList}
          setIsVideoProcessing={setIsVideoProcessing}
          setProgress={setProgress}
          restrictedViewerToken={restrictedViewerToken}
          setCompanyStats={setCompanyStats}
          CompanyStatsCount={CompanyStatsCount}
          isLiked={isLiked}
          setIsLiked={setIsLiked}
        />}

      {isLoading ? (
        <div className="mt-3">
          <div className="text-center">
            <img src={post?.loader} width={50} />
          </div>
        </div>
      )
        : isError || postList.length === 0 ? (
          <div className="mt-2 text-center">
            <img src={post.errorSmall} alt="404 Not Found" width={200} />
          </div>
        ) : (
          <>
                    {postsWithAds
                       ?.filter((item) => !item.isDeleted)
                         .map((item, index) => {
                   const now = moment.utc().local();
                    const itemTime = moment.utc(item?.postInfo?.creationTime).local();

                    const diffSeconds = now.diff(itemTime, "seconds");
                    const diffMinutes = now.diff(itemTime, "minutes");
                    const diffHours = now.diff(itemTime, "hours");
                    const diffDays = now.diff(itemTime, "days");

                    const diffMonths = now.diff(itemTime, "months", true);
                    const diffYears = now.diff(itemTime, "years", true);

                    let result = "";

                    /* JUST NOW */
                    if (diffSeconds < 60) {
                      result = t("Notifications.Just Now");
                    }

                    /* MINUTES */
                    else if (diffMinutes < 60) {
                      result =
                        diffMinutes === 1
                          ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                          : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
                    }

                    /* HOURS */
                    else if (diffHours < 24) {
                      result =
                        diffHours === 1
                          ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                          : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
                    }

                    /* DAYS */
                    else if (diffDays < 30) {
                      result =
                        diffDays === 1
                          ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                          : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
                    }

                    /* MONTHS */
                    else if (diffMonths < 12) {
                      const displayMonth =
                        diffMonths >= 0.75 && diffMonths < 1.25
                          ? 1
                          : Math.round(diffMonths * 2) / 2;

                      result =
                        displayMonth === 1
                          ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                          : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
                    }

                    /* YEARS */
                    else {
                      const displayYear =
                        diffYears >= 0.75 && diffYears < 1.25
                          ? 1
                          : Math.round(diffYears * 2) / 2;

                      result =
                        displayYear === 1
                          ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                          : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
                    }
                           return (
                             <React.Fragment key={`post-${index}`}>
                               {item.isAd && (
                                <Advertisement key={`ad-${index}`} />
                                )}
                                {!item.isAd &&  (
                                  <div
                                    className="featured-card user-postOnlyContent p-2 mb-3"
                                    key={index}
                                  >
                                    <div className="feature-content p-2 d-flex justify-content-between">
                                      <Link to={`/Company/${item?.postInfo?.userUid}`}>
                                        <div className="d-flex align-items-center">
                                          <div className="ImgAvatar">
                                            <img
                                              src={item?.postInfo?.userAvatar}
                                              alt=""
                                              style={{ borderRadius: "50px" }}
                                            />
                                          </div>
                                          <div className="ms-2">
                                            <h4 className="f-14 fw-bold mb-0">{item?.postInfo?.userName} </h4>
                                            <p className="f-12">{item?.postInfo?.title}</p>
                                            <p className="f-12">{item?.postInfo?.additionalInfo}</p>
                                            {/* <p className="f-10 label">
                                              {moment
                                                .utc(item?.postInfo?.creationTime)
                                                .local()
                                                .format("DD MMMM YYYY [at] h:mm a")}
                                            </p> */}
                                            {language === "ar" ? (
                                                <Tooltip title={moment
                                                  .utc(item?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                              <p className="f-10 label"> 
                                                {moment
                                                  .utc(item?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format("D MMMM YYYY [الساعة] h:mm a" )}
                                              </p>
                                           </Tooltip>
                                        ) : (
                                           <Tooltip title={moment
                                                  .utc(item?.postInfo?.creationTime)
                                                  .local()
                                                 .format(language === "en"
                                                      ? "D MMMM YYYY [at] h:mm a"
                                                      :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                              <p className="f-10 label"> 
                                                {result}
                                                {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                              </p>
                                           </Tooltip> 
                                            

                                        )}
                                          </div>

                                        </div>
                                      </Link>

                                      {guestModeData === "true" ? (
                                        ""
                                      ) : (
                                        <div className="row">
                                          <div>
                                            <PostInteractionModal
                                              postId={item?.postInfo?.postId}
                                              AllPostList={AllPostList}
                                              postList={postList}
                                              setPage={setPage}
                                              setPostList={setPostList}
                                              page={page}
                                              setTotalPages={setTotalPages}
                                              totalPages={totalPages}
                                              item={item}
                                              PostOriginType={"Company"}
                                              postOriginId={item?.postInfo?.userUid}
                                              isfollowed={isfollowed}
                                              setIsfollowed={setIsfollowed}
                                              setShowDeletePost={setShowDeletePost}
                                              showDeletePost={showDeletePost}
                                              ispinned={item?.postInfo?.postActionsInfo?.isPinned}
                                              setCompanyStats={setCompanyStats}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    <PostComponent item={item} restrictedViewerToken={restrictedViewerToken}/>
                                    <div
                                      className="feed-post"
                                      style={{
                                        paddingTop: item?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
                                      }}
                                    >

                                      <div className="row">
                                        {console.warn(
                                          "===========0============>>",
                                          item.mediaFilesList
                                        )}
                                        {item?.postInfo?.mediaFilesList?.map((file, idx) => (
                                          <div
                                            key={idx}
                                            className={`col-${item?.postInfo?.mediaFilesList.length === 1 ? "12" : "6"
                                              } ${item?.postInfo?.mediaFilesList.length === 3 && idx === 0
                                                ? "col-12"
                                                : ""
                                              }`}
                                            onClick={() => {
                                              setInitialSlideIndex(idx);
                                              setImageArray(item?.postInfo?.mediaFilesList);
                                              console.warn("===========1============>>", idx);
                                              let imageData = item?.postInfo?.mediaFilesList.map(
                                                (file) => file.mediaName
                                              );
                                              // openModal(imageData, idx);
                                              if (
                                                                item?.cntntTypCategory !== 'Video' && 
                                                                (item?.cntntTypCategory === 'UserStory' || 
                                                                item?.cntntTypCategory === 'Text' || 
                                                                item?.cntntTypCategory === 'TextWithImage' || 
                                                                item?.cntntTypCategory === 'Image')
                                                              ) {
                                                                openModal(imageData, 1);
                                                              } 
                                                              if (
                                                                item?.cntntTypCategory === 'Article' ||
                                                                item?.contentType === 'ArticlePost'
                                                              ) { 
                                                                window.open(`/Article/${item?.postInfo?.postId}/${item?.postInfo?.articleInfo?.titleSlug}`, '_blank'); 
                                                              }

                                              setSinglePostContent(item?.postInfo);
                                              setSinglePostId(item?.postInfo?.postId);
                                            }}
                                            style={{
                                              position: "relative",
                                              padding:
                                                item?.postInfo?.mediaFilesList.length === 3 && idx === 0
                                                  ? "0 0 5px 0"
                                                  : item?.postInfo?.mediaFilesList.length === 3 && idx === 1
                                                    ? "0 5px 5px 0"
                                                    : item?.postInfo?.mediaFilesList.length === 4 && idx === 2
                                                      ? "0 5px 0 0"
                                                      : item?.postInfo?.mediaFilesList.length === 4 && idx === 0
                                                        ? "0 5px 5px 0"
                                                        : item?.postInfo?.mediaFilesList.length === 2 && idx === 0
                                                          ? "0 5px 5px 0"
                                                          : "",
                                            }}
                                          >
                                            {/* <img
                                                src={file.mediaName}
                                                alt=""
                                                className="img-fluid"
                                                width={"100%"}
                                              /> */}
                                            {item?.cntntTypCategory !== 'TextWithVideo' && item?.cntntTypCategory !== 'Video' ?
                                              <ImageWithLoader
                                                src={file?.mediaName}
                                                alt=""
                                                className="img-fluid modal-imag"
                                                width={"100%"}
                                                onError={(e) => {
                                                  if (!e?.target) return;
                                                  e.target.onerror = null;
                                                  e.target.src = post.noimgavailable;
                                                }}
                                              /> : null}
                                            {item?.cntntTypCategory === 'TextWithVideo' || item?.cntntTypCategory === 'Video' ?
                                            <div  className="newsfeed-video">
                                              {/* <iframe width="100%" height="300"
                                                src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${file?.mediaInfo}/?accessToken=${restrictedViewerToken}&location=centralindia&controls=true&autoplay=false`} frameborder="0" allowfullscreen allow="autoplay; fullscreen"
                                              ></iframe> */}
                                              {/* <video
                                                ref={(el) => videoRefs.current[file?.mediaInfo] = el}
                                                id={`video-${file?.mediaInfo}`}
                                                poster={`data:image/jpeg;base64,${file?.videoIndexInsight?.thumbnail}`}
                                                controls
                                                autoPlay
                                                width="100%"
                                                className="rounded shadow"
                                                style={{ aspectRatio: '16/9', width: '100%', height: 'auto' }}
                                                playsInline
                                                muted
                                              /> */}
                                              <PostVideoCommon file={file} item={item}
                                                restrictedViewerToken={restrictedViewerTokens}
                                                activeVideoId={activeVideoId}
                                                setActiveVideoId={setActiveVideoId}
                                                visibleVideoRef={visibleVideoRef} />
                                                  </div> : null}
                                            {idx === 3 && item?.postInfo?.postMediaCount > 4 && (
                                              <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                                +{item?.postInfo?.postMediaCount - 4}
                                              </div>
                                            )}

                                          </div>
                                        ))}
                                      </div>
                                      {guestModeData === "true" ? (
                                        ""
                                      ) : (
                                        <div className="row comment-gradient">
                                          <div
                                            className="addComment"
                                            onClick={() => {
                                              openModal(
                                                (item?.postInfo?.mediaFilesList || []).map((file) => file.mediaName),
                                                0
                                              );
                                              setSinglePostContent(item);
                                              setSinglePostId(item?.postInfo?.postId);
                                            }}
                                          >
                                            <div
                                              className="postCommentWrapper"
                                              onClick={(event) => event.stopPropagation()}
                                            >
                                              <PostComment
                                                item={item}
                                                postId={item?.postInfo?.postId}
                                                AllPostList={AllPostList}
                                                postList={postList}
                                                setPage={setPage}
                                                setPostList={setPostList}
                                                page={page}
                                                setTotalPages={setTotalPages}
                                                totalPages={totalPages}
                                                updateCommentCount={updateCommentCount}
                                                ispostmodalOpen={ispostmodalOpen}
                                                setIspostmodalOpen={setIspostmodalOpen}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    <div className={`postData d-flex align-items-center ${item?.postInfo?.likeCount === 0 && item?.postInfo?.commentCount === 0 && item?.postInfo?.shareCount === 0
                                      ? ""
                                      : "border-custom1"
                                      }`}>
                                      <div className="ms-2">
                                        {item?.postInfo?.likeCount === 0 || item?.postInfo?.likeCount === null ? (
                                          ""
                                        ) : (
                                          <p
                                            className="f-10 like-details"
                                            onClick={() => handleShowModal(item)}
                                          >
                                            {item?.postInfo?.likeCount + dLike} <ThumbUpOutlinedIcon  style={{color:"#00419f", fontSize: "13px"}}/>
                                            {/* {t("Newsfeed.Like")} */}
                                          </p>
                                        )}
                                      </div>
                                      <div className="ms-auto d-flex">
                                        {item?.postInfo?.commentCount === 0 || item?.postInfo?.commentCount === null  ? (
                                          ""
                                        ) : (
                                          <p
                                            className="f-10 me-2 pointer"
                                            onClick={() => {
                                              openModal(
                                                item?.postInfo?.mediaFilesList?.map((file) => file.mediaName)
                                              );
                                              setSinglePostContent(item?.postInfo);
                                              setSinglePostId(item?.postInfo?.postId);
                                            }}
                                          >
                                            {" "}
                                            {item?.postInfo?.commentCount}  <ChatOutlinedIcon 
                                        style={{color:"#00419f", fontSize: "13px"}}/>
                                            {/* {t("Newsfeed.Comment")} */}
                                          </p>
                                        )}
 
                                        <p className="f-10">
                                  {item?.postInfo?.shareCount === 0 || item?.postInfo?.shareCount === null
                                    ? ""
                                    : `&  ${item?.postInfo?.shareCount}`} {item?.postInfo?.shareCount === 0 || item?.postInfo?.shareCount === null
                                    ? ""
                                    : <ReplyAllOutlinedIcon className=" ms-1" style={{color:"#00419f",fontSize: "large"}} />
                                     }
                                </p>
                                      </div>
                                    </div>
                                    <div className="postengagement mb-1">
                                      <PostEngagement
                                        setIsLiked={setIsLiked}
                                        isLiked={isLiked}
                                        item={item}
                                        postId={item?.postInfo?.postId}
                                        AllPostList={AllPostList}
                                        postList={postList}
                                        setPage={setPage}
                                        setPostList={setPostList}
                                        page={page}
                                        setTotalPages={setTotalPages}
                                        totalPages={totalPages}
                                        updateLikeCount={updateLikeCount}
                                        updateShareCount={updateShareCount}
                                        openModal={openModal}
                                        setSinglePostContent={setSinglePostContent}
                                        setSinglePostId={setSinglePostId}
                                        ispostmodalOpen={ispostmodalOpen}
                                        setIspostmodalOpen={setIspostmodalOpen}
                                        emojiList={emojiList}
                                       setCompanyStats={setCompanyStats}
                            updatePostLike={updatePostLike}

                                      />
                                    </div>
                                    <Comment
                                      item={item}
                                      postId={item?.postInfo?.postId}
                                      AllPostList={AllPostList}
                                      postList={postList}
                                      setPage={setPage}
                                      setPostList={setPostList}
                                      page={page}
                                      setTotalPages={setTotalPages}
                                      totalPages={totalPages}
                                      emojiList={emojiList}
                                    />
                                  </div>
                              )}
                           </React.Fragment>
                          );
                        })}          
                 </>
          // postList &&
          // postList?.map((item, index) => {
          //   console.log('gsadfghdsa', item);
          //   return (
          //     <div
          //       className="featured-card user-postOnlyContent p-2 mb-3"
          //       key={index}
          //     >
          //       <div className="feature-content p-2 d-flex justify-content-between">
          //         <Link to={`/Company/${item?.postInfo?.userUid}`}>
          //           <div className="d-flex align-items-center">
          //             <div className="ImgAvatar">
          //               <img
          //                 src={item?.postInfo?.userAvatar}
          //                 alt=""
          //                 style={{ borderRadius: "50px" }}
          //               />
          //             </div>
          //             <div className="ms-2">
          //               <h4 className="f-14 fw-bold mb-0">{item?.postInfo?.userName} </h4>
          //               <p className="f-12">{item?.postInfo?.title}</p>
          //               <p className="f-12">{item?.postInfo?.additionalInfo}</p>
          //               <p className="f-10 label">
          //                 {moment
          //                   .utc(item?.postInfo?.creationTime)
          //                   .local()
          //                   .format("DD MMMM YYYY [at] h:mm a")}
          //               </p>
          //             </div>

          //           </div>
          //         </Link>

          //         {guestModeData === "true" ? (
          //           ""
          //         ) : (
          //           <div className="row">
          //             <div>
          //               <PostInteractionModal
          //                 postId={item?.postInfo?.postId}
          //                 AllPostList={AllPostList}
          //                 postList={postList}
          //                 setPage={setPage}
          //                 setPostList={setPostList}
          //                 page={page}
          //                 setTotalPages={setTotalPages}
          //                 totalPages={totalPages}
          //                 item={item}
          //                 PostOriginType={"Company"}
          //                 postOriginId={item?.postInfo?.userUid}
          //                 isfollowed={isfollowed}
          //                 setIsfollowed={setIsfollowed}
          //                 setShowDeletePost={setShowDeletePost}
          //                 showDeletePost={showDeletePost}
          //                 ispinned={item?.postInfo?.postActionsInfo?.isPinned}
          //               />
          //             </div>
          //           </div>
          //         )}
          //       </div>

          //       <PostComponent item={item} restrictedViewerToken={restrictedViewerToken}/>
          //       <div
          //         className="feed-post"
          //         style={{
          //           paddingTop: item?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
          //         }}
          //       >

          //         <div className="row">
          //           {console.warn(
          //             "===========0============>>",
          //             item.mediaFilesList
          //           )}
          //           {item?.postInfo?.mediaFilesList?.map((file, idx) => (
          //             <div
          //               key={idx}
          //               className={`col-${item?.postInfo?.mediaFilesList.length === 1 ? "12" : "6"
          //                 } ${item?.postInfo?.mediaFilesList.length === 3 && idx === 0
          //                   ? "col-12"
          //                   : ""
          //                 }`}
          //               onClick={() => {
          //                 setInitialSlideIndex(idx);
          //                 setImageArray(item?.postInfo?.mediaFilesList);
          //                 console.warn("===========1============>>", idx);
          //                 let imageData = item?.postInfo?.mediaFilesList.map(
          //                   (file) => file.mediaName
          //                 );
          //                 // openModal(imageData, idx);
          //                 if (
          //                                   item?.cntntTypCategory !== 'Video' && 
          //                                   (item?.cntntTypCategory === 'UserStory' || 
          //                                   item?.cntntTypCategory === 'Text' || 
          //                                   item?.cntntTypCategory === 'TextWithImage' || 
          //                                   item?.cntntTypCategory === 'Image')
          //                                 ) {
          //                                   openModal(imageData, 1);
          //                                 } 
          //                                 if (
          //                                   item?.cntntTypCategory === 'Article' ||
          //                                   item?.contentType === 'ArticlePost'
          //                                 ) { 
          //                                   window.open(`/Article/${item?.postInfo?.postId}/${item?.postInfo?.articleInfo?.titleSlug}`, '_blank'); 
          //                                 }

          //                 setSinglePostContent(item?.postInfo);
          //                 setSinglePostId(item?.postInfo?.postId);
          //               }}
          //               style={{
          //                 position: "relative",
          //                 padding:
          //                   item?.postInfo?.mediaFilesList.length === 3 && idx === 0
          //                     ? "0 0 5px 0"
          //                     : item?.postInfo?.mediaFilesList.length === 3 && idx === 1
          //                       ? "0 5px 5px 0"
          //                       : item?.postInfo?.mediaFilesList.length === 4 && idx === 2
          //                         ? "0 5px 0 0"
          //                         : item?.postInfo?.mediaFilesList.length === 4 && idx === 0
          //                           ? "0 5px 5px 0"
          //                           : item?.postInfo?.mediaFilesList.length === 2 && idx === 0
          //                             ? "0 5px 5px 0"
          //                             : "",
          //               }}
          //             >
          //               {/* <img
          //                   src={file.mediaName}
          //                   alt=""
          //                   className="img-fluid"
          //                   width={"100%"}
          //                 /> */}
          //               {item?.cntntTypCategory !== 'TextWithVideo' || item?.cntntTypCategory !== 'Video' ?
          //                 <img
          //                   src={file?.mediaName}
          //                   alt=""
          //                   className="img-fluid"
          //                   width={"100%"}
          //                 /> : null}
          //               {item?.cntntTypCategory === 'TextWithVideo' || item?.cntntTypCategory === 'Video' ?
          //                <div  className="newsfeed-video">
          //                 {/* <iframe width="100%" height="300"
          //                   src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${file?.mediaInfo}/?accessToken=${restrictedViewerToken}&location=centralindia&controls=true&autoplay=false`} frameborder="0" allowfullscreen allow="autoplay; fullscreen"
          //                 ></iframe> */}
          //                 <video
          //                   ref={(el) => videoRefs.current[file?.mediaInfo] = el}
          //                   id={`video-${file?.mediaInfo}`}
          //                   poster={`data:image/jpeg;base64,${file?.videoIndexInsight?.thumbnail}`}
          //                   controls
          //                    autoPlay
          //                   width="100%"
          //                   className="rounded shadow"
          //                   style={{ aspectRatio: '16/9', width: '100%', height: 'auto' }}
          //                   playsInline
          //                   muted
          //                 />
          //               </div> : null}
          //               {idx === 3 && item?.postInfo?.postMediaCount > 4 && (
          //                 <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
          //                   +{item?.postInfo?.postMediaCount - 4}
          //                 </div>
          //               )}
          //             </div>
          //           ))}
          //         </div>
          //         {guestModeData === "true" ? (
          //           ""
          //         ) : (
          //           <div className="row comment-gradient">
          //             <div
          //               className="addComment"
          //               onClick={() => {
          //                 openModal(
          //                   item?.postInfo?.mediaFilesList.map((file) => file.mediaName),
          //                   0
          //                 );
          //                 setSinglePostContent(item);
          //                 setSinglePostId(item?.postInfo?.postId);
          //               }}
          //             >
          //               <div
          //                 className="postCommentWrapper"
          //                 onClick={(event) => event.stopPropagation()}
          //               >
          //                 <PostComment
          //                   item={item}
          //                   postId={item?.postInfo?.postId}
          //                   AllPostList={AllPostList}
          //                   postList={postList}
          //                   setPage={setPage}
          //                   setPostList={setPostList}
          //                   page={page}
          //                   setTotalPages={setTotalPages}
          //                   totalPages={totalPages}
          //                   updateCommentCount={updateCommentCount}
          //                   ispostmodalOpen={ispostmodalOpen}
          //                   setIspostmodalOpen={setIspostmodalOpen}
          //                 />
          //               </div>
          //             </div>
          //           </div>
          //         )}
          //       </div>

          //       <div className={`postData d-flex align-items-center ${item?.postInfo?.likeCount === 0 && item?.postInfo?.commentCount === 0 && item?.postInfo?.shareCount === 0
          //         ? ""
          //         : "border-custom1"
          //         }`}>
          //         <div className="ms-2">
          //           {item?.postInfo?.likeCount === 0 ? (
          //             ""
          //           ) : (
          //             <p
          //               className="f-10 like-details"
          //               onClick={() => handleShowModal(item)}
          //             >
          //               {item?.postInfo?.likeCount + dLike} likes
          //             </p>
          //           )}
          //         </div>
          //         <div className="ms-auto d-flex">
          //           {item?.postInfo?.commentCount === 0 ? (
          //             ""
          //           ) : (
          //             <p
          //               className="f-10 me-2 pointer"
          //               onClick={() => {
          //                 openModal(
          //                   item?.postInfo?.mediaFilesList?.map((file) => file.mediaName)
          //                 );
          //                 setSinglePostContent(item?.postInfo);
          //                 setSinglePostId(item?.postInfo?.postId);
          //               }}
          //             >
          //               {" "}
          //               {item?.postInfo?.commentCount} comments{" "}
          //             </p>
          //           )}

          //           <p className="f-10">
          //             {item?.postInfo?.shareCount === 0
          //               ? ""
          //               : `&  ${item?.postInfo?.shareCount} Shares`}
          //           </p>
          //         </div>
          //       </div>
          //       <div className="postengagement mb-3">
          //         <PostEngagement
          //           item={item}
          //           postId={item?.postInfo?.postId}
          //           AllPostList={AllPostList}
          //           postList={postList}
          //           setPage={setPage}
          //           setPostList={setPostList}
          //           page={page}
          //           setTotalPages={setTotalPages}
          //           totalPages={totalPages}
          //           updateLikeCount={updateLikeCount}
          //           updateShareCount={updateShareCount}
          //           openModal={openModal}
          //           setSinglePostContent={setSinglePostContent}
          //           setSinglePostId={setSinglePostId}
          //           ispostmodalOpen={ispostmodalOpen}
          //           setIspostmodalOpen={setIspostmodalOpen}
          //           emojiList={emojiList}
          //         />
          //       </div>
          //       <Comment
          //         item={item}
          //         postId={item?.postInfo?.postId}
          //         AllPostList={AllPostList}
          //         postList={postList}
          //         setPage={setPage}
          //         setPostList={setPostList}
          //         page={page}
          //         setTotalPages={setTotalPages}
          //         totalPages={totalPages}
          //         emojiList={emojiList}
          //       />
          //     </div>
          //   );
          // })
        )}

      {!hasMoreData && postList.length > 8  && (
        <p className="text-center">{t("Newsfeed.No more data available")}</p >
      )}
       {/* {(page > 1 && !hasMoreData) &&(
                <p className="text-center">No more data available</p >
            )} */}
      {nextBatchLoading && !isLoading && (
        <div className="text-center mb-4">
          <img src={post?.loader} width={50} />
        </div>
      )}

      {isModalOpen && (
        <ImageSliderModal
          isOpen={isModalOpen}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          onRequestClose={closeModal}
          images={modalImages}
          item={singlePostContent}
          singlepostId={singlepostId}
          setSinglePostId={setSinglePostId}
          updateShareCount={updateShareCount}
          updateLikeCount={updateLikeCount}
          totalPages={totalPages}
          setTotalPages={setTotalPages}
          page={page}
          setPostList={setPostList}
          setPage={setPage}
          postList={postList}
          AllPostList={AllPostList}
          PostEngagement={PostEngagement}
          dLike={dLike}
          updateCommentCount={updateCommentCount}
          ispostmodalOpen={ispostmodalOpen}
          setIspostmodalOpen={setIspostmodalOpen}
          openModal={openModal}
          setSinglePostContent={setSinglePostContent}
          setDLike={setDLike}
          setShowModal={showModal}
          handleLikesCloseModal={handleLikesCloseModal}
          isfollowed={isfollowed}
          setIsfollowed={setIsfollowed}
          initialSlideIndex={initialSlideIndex}
          setInitialSlideIndex={setInitialSlideIndex}
          imageArray={imageArray}
          restrictedViewerToken={restrictedViewerToken}
          updateCommentLike={updateCommentLike}
          updatePostLike={updatePostLike}
          updateReplyCommentLike={updateReplyCommentLike}
        />
      )}

      <LikesDetails
        showModal={showModal}
        handleLikesCloseModal={handleLikesCloseModal}
        postId={postId}
        postLikedType={postLikedType}
        setShowModal={setShowModal}
      />
    </>
  );
};

export default Posts;
